import { SystemFieldNames, SystemFieldGroups } from './systemFieldConstants'
import type { QField } from '~/features/questionnaire/types'
import type { SystemFieldDetails } from './systemFieldConstants'

const
  MEASUREMENT_START_UNITS = {
    BEFORE_PLANTING: 'days before planting',
    AFTER_PLANTING: 'days after planting',
    AFTER_GERMINATION: 'days after germination'
  } as const,
  title = 'Unit for timing of first or only measurement',
  description = 'Provides a reference point for the timing of the first measurement so that it can be accurately incorporated into the schedule.',
  schemaEntry: QField = {
    fieldName: SystemFieldNames.measurementStartUnit,
    fieldType: 'ENUM',
    options: [
      { optionValue: MEASUREMENT_START_UNITS.BEFORE_PLANTING },
      { optionValue: MEASUREMENT_START_UNITS.AFTER_PLANTING },
      { optionValue: MEASUREMENT_START_UNITS.AFTER_GERMINATION }
    ]
  },
  fieldDetails: SystemFieldDetails = {
    fieldName: SystemFieldNames.measurementStartUnit,
    variableGroup: SystemFieldGroups.SCHEDULE,
    isRequired: false,
    title,
    description,
    schemaEntry
  }

export {
  fieldDetails,
  MEASUREMENT_START_UNITS
}
